import moment from 'moment';
import { DateTime } from 'luxon';
import { getTimezoneOffset } from '@/common/timezone/timezone';

export const applyTimezoneOffset = (date: string, addTimezone: boolean): string => {
  if (!date) {
    return null;
  }
  const timezoneOffset: number = getTimezoneOffset();
  if (!timezoneOffset) {
    return date;
  }
  const dateWithOffset = addTimezone
    ? moment(date).add(timezoneOffset, 'hours')
    : moment(date).add(-timezoneOffset, 'hours');
  if (!dateWithOffset.isValid()) {
    return null;
  }
  return new Date(dateWithOffset.toString()).toISOString();
};

export const getTimezoneAsString = (): string => {
  const date = DateTime.now();
  const isDST = date.isInDST;
  const offset = date.offset - (isDST ? 60 : 0);
  const absoluteOffset = Math.abs(offset);
  const operator = offset > 0 ? '+' : '-';
  const hours = `00${Math.floor(absoluteOffset / 60)}`.slice(-2);
  const minutes = `00${absoluteOffset % 60}`.slice(-2);

  return `${operator}${hours}:${minutes}`;
};
